import React, { useState, useEffect } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import {BrowserRouter,Routes,Route,useLocation} from 'react-router-dom';
 import Home from "./elements/Home";
import CategoryProducts from "./elements/CategoryProducts";
import Cart from "./elements/Cart";
import Signup from "./elements/Signup";
import Login from "./elements/Login";
import Checkout from "./elements/Checkout";
import Footer from "./elements/Footer";
import SearchProducts from "./elements/SearchProducts";
import Profile from "./elements/Profile";
import Products from "./elements/products";
import Allproducts from "./elements/Allproducts";
import Support from "./elements/support";
import MyProduct from "./elements/MyProduct";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [showCart, setShowCart] = useState(false);
  const [mycart, setMycart] = useState([]);
  const [isCartInitialized, setIsCartInitialized] = useState(false);

  // Load cart state from localStorage on mount
  useEffect(() => {
    console.log('Loading cart from localStorage...');
    const storedCart = localStorage.getItem('mycart');
    console.log('localStorage.getItem("mycart") returned:', storedCart);
    if (storedCart) {
      try {
        const parsedCart = JSON.parse(storedCart);
        console.log('Loaded cart:', parsedCart);
        setMycart(parsedCart);
      } catch (e) {
        console.error('Failed to parse stored cart:', e);
      }
    } else {
      console.log('No cart found in localStorage');
    }
    setIsCartInitialized(true);
  }, []);

  // Save cart state to localStorage when mycart changes and cart is initialized
  useEffect(() => {
    if (isCartInitialized) {
      console.log('Saving cart to localStorage:', mycart);
      localStorage.setItem('mycart', JSON.stringify(mycart));
    }
  }, [mycart, isCartInitialized]);

  const handleAddToCart = (product) => {
    setMycart(prev => {
      // Check if product already exists in cart
      const existingIndex = prev.findIndex(item => item.item_id === product.item_id);
      if (existingIndex !== -1) {
        // If exists, increase quantity
        const newCart = [...prev];
        const existingItem = newCart[existingIndex];
        const newQuantity = (existingItem.quantity || 1) + 1;
        newCart[existingIndex] = { ...existingItem, quantity: newQuantity };
        return newCart;
      } else {
        // If not exists, add with quantity 1
        return [...prev, { ...product, quantity: 1 }];
      }
    });
    setShowCart(true);
  };

  const handleRemoveItem = (index) => {
    setMycart(prev => {
      const newCart = [...prev];
      newCart.splice(index, 1);
      return newCart;
    });
  };

  const handleCartToggle = () => {
    setShowCart(prev => !prev);
  };

  const handleClearCart = () => {
    setMycart([]);
  };

  // Derive cartItems count from sum of quantities in mycart
  const cartItems = mycart.reduce((total, item) => {
    return total + (item.quantity || 1);
  }, 0);

  // Calculate total price of items in cart
  const cartTotal = mycart.reduce((total, item) => {
    const price = parseFloat(item.item_price || item.sell_price || 0);
    const quantity = item.quantity || 1;
    return total + (isNaN(price) ? 0 : price * quantity);
  }, 0);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home
          cartItems={cartItems} 
          onAddToCart={handleAddToCart}
          cartList={mycart} // Pass the cart items to the Header
          cartTotal={cartTotal}
          showCart={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
        />} />
        <Route path="/category/:category" element={<CategoryProducts 
          cartItems={cartItems}
          onAddToCart={handleAddToCart}
          cartList={mycart}
          cartTotal={cartTotal}
          showCart={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
        />} />
        <Route path="/size/:size" element={<CategoryProducts
          cartItems={cartItems}
          onAddToCart={handleAddToCart}
          cartList={mycart}
          cartTotal={cartTotal}
          showCart={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
        />} />
        <Route path="/trolly" element={<CategoryProducts
          cartItems={cartItems}
          onAddToCart={handleAddToCart}
          cartList={mycart}
          cartTotal={cartTotal}
          showCart={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
        />} />

         <Route path="/products" element={<Products 
          cartItems={cartItems}
          onAddToCart={handleAddToCart}
          cartList={mycart}
          cartTotal={cartTotal}
          showCart={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
        />} />
        <Route path="/allproducts" element={<Allproducts 
          cartItems={cartItems}
          onAddToCart={handleAddToCart}
          cartList={mycart}
          cartTotal={cartTotal}
          showCart={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
        />} />
        <Route path="/cart" element={<Cart 
          cartItems={cartItems}
          cartList={mycart} 
          cartTotal={cartTotal} 
          showCartDropdown={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
          onQuantityChange={(index, newQuantity) => {
            setMycart(prev => {
              const newCart = [...prev];
              if (newQuantity < 1) return newCart;
              if (index >= 0 && index < newCart.length) {
                newCart[index] = { ...newCart[index], quantity: newQuantity };
              }
              return newCart;
            });
          }}
        />} />
        <Route path="/checkout" element={<Checkout 
          cartList={mycart}
          cartTotal={cartTotal}
          onRemoveItem={handleRemoveItem}
          onClearCart={handleClearCart}
        />} />
         <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/search" element={<SearchProducts
          cartList={mycart}
          onAddToCart={handleAddToCart}
          cartItems={cartItems}
          cartTotal={cartTotal}
          showCartDropdown={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
        />} />
        <Route path="/profile" element={<Profile 
          cartItems={cartItems}
          cartList={mycart}
          showCartDropdown={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
        />} />
        <Route path="/support" element={<Support />} />
        <Route path="/myproduct/:id" element={<MyProduct
          cartItems={cartItems}
          onAddToCart={handleAddToCart}
          cartList={mycart}
          cartTotal={cartTotal}
          showCart={showCart}
          onCartToggle={handleCartToggle}
          onRemoveItem={handleRemoveItem}
        />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  ); 
}

export default App;
